import { Reveal } from "./Reveal";
import { LANDING } from "@/data/pageCopy";


const { kicker, h2, personas } = LANDING.whoFor;

export const WhoFor = () => (
  <section className="relative py-24 md:py-32 bg-[#0a0a0a] border-t border-white/10" data-testid="who-section">
    <div className="mx-auto max-w-[1400px] px-6 md:px-12">
      <Reveal>
        <p className="font-mono-t text-xs uppercase tracking-[0.25em] text-[#5B8CFF] mb-4">{kicker}</p>
        <h2 className="font-heading font-medium tracking-tight text-3xl md:text-4xl lg:text-5xl max-w-2xl text-white">
          {h2}
        </h2>
      </Reveal>

      <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
        {personas.map((p, i) => (
          <Reveal key={p.t} delay={i * 0.08}>
            <div className="h-full bg-white/[0.02] p-8 hover:bg-white/[0.05] transition-colors duration-300 min-h-[220px] flex flex-col">
              <p.icon className="text-white" size={26} />
              <h3 className="mt-6 font-heading font-semibold text-lg text-white">{p.t}</h3>
              <p className="mt-3 text-neutral-400 text-sm leading-relaxed">{p.d}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
